import Tool, { type IToolActionInput } from './Tool';
import { createViewportHash, type Vpt } from '../utils/zoom';

class ToolCopyViewportUrl extends Tool {
  static toolName = 'Copy link to current view';

  static available() {
    return true; // Available in all contexts, even read-only
  }

  static enabled() {
    return true;
  }

  static action({ controller }: IToolActionInput) {
    const canvas = controller.canvas;
    if (!canvas?.viewportTransform) return;

    const vpt = canvas.viewportTransform as Vpt;

    const hash = createViewportHash(vpt);

    const whiteboardUrl = controller.getWhiteboardUrl();
    if (!whiteboardUrl) return;

    const url = new URL(whiteboardUrl);
    url.hash = hash;

    navigator.clipboard.writeText(url.toString()).catch(err => {
      console.error('Failed to copy URL: ', err);
    });
  }
}

export default ToolCopyViewportUrl;
